<template>
  <div class="participant-portal">
    <Header />
    <div id="content-wrapper">
      <div class="container relative" :class="{'nav-open': showNavigation && isLoggedIn, 'dashboard': hasSidebarSpacingCss}">
        <DeviceAuth />
        <DashboardNotifications />
        <RouterViewWithLoader :fixed="true" />
      </div>
    </div>
    <Footer />
    <Notifications />
    <Navigation />
    <SessionTimeout />
  </div>
</template>

<script>
  import { mapState , mapGetters } from 'vuex';

  import RouterViewWithLoader from '@ui/RouterViewWithLoader.vue';
  import Header from './components/Header.vue';
  import Footer from './components/Footer.vue';
  import Notifications from './components/Notifications.vue';
  import Navigation from './components/Navigation.vue';
  import DeviceAuth from "./components/DeviceAuth.vue";
  import DashboardNotifications from './components/DashboardNotifications.vue';
  import SessionTimeout from "./components/SessionTimeout.vue";

  export default {
    name: "Portal",
    components: {
      DeviceAuth,
      Header,
      Footer,
      Notifications,
      Navigation,
      DashboardNotifications,
      RouterViewWithLoader,
      SessionTimeout
    },
    computed: {
      ...mapState(['loading', 'showNavigation', 'hideNavigationButton']),
      ...mapGetters(['isLoggedIn', 'isStartedParticipant', 'isArmWithPortal']),
      hasSidebarSpacingCss() {
        return this.isLoggedIn && this.isStartedParticipant
          && this.isArmWithPortal && !this.hideNavigationButton;
      },
    },
  }
</script>

<style scoped>

  #content-wrapper {
    flex: 1 0 auto;
    margin-top: 56px;
  }

  .participant-portal {
    flex: auto;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
  }

  .participant-portal #content-wrapper {
    min-height: 300px;
  }

  @media (max-width: 1200px) {
    .participant-portal #content-wrapper {
      overflow-x: auto;
    }

    .participant-portal #content-wrapper .container.nav-open {
      overflow-x: hidden;
      transform: translateX(300px);
    }

    .participant-portal #content-wrapper .container {
      transition: transform .5s ease-out, box-shadow .5s ease-out;
    }
  }

  @media (min-width: 1200px) {
    .participant-portal #content-wrapper .container.dashboard {
      padding-left: 300px;
    }
  }

  >>> .spinner-outer {
    z-index: 1020;
  }

  >>> .notification-message {
    white-space: pre-line;
    overflow-wrap: break-word;
  }
</style>
